export const SEND_CODE = "/api/send_phone_code";
export const LOGIN = "/api/login";
export const LOGOUT = "/api/logout";
